import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../../../stores/CurrentCompanyStore'
import moment from 'moment'
import { Currency } from '../../../../../../components/Currency'
import { Descriptions, Input, Icon } from 'antd'
import { AuditDescriptionStore } from '../AuditDescriptionStore'
import { AuditStore } from '../EditAuditStore'
import { AuditModels } from '@getgreenline/audits'
import { BLAZE_COMPANY } from '../../../../../../constants/general'

interface Props {
  audit: AuditModels.CreateInventoryAudit
  currentCompanyStore?: CurrentCompanyStore
  auditStore: AuditStore
}

@inject('currentCompanyStore')
@observer
export class AuditDescription extends React.Component<Props> {
  auditDetail = new AuditDescriptionStore(this.props.audit)

  render() {
    const { audit, auditStore } = this.props

    return (
      <Descriptions bordered size='small' column={{ lg: 1, md: 1, sm: 1, xs: 1 }}>
        <Descriptions.Item
          label='Title'
          className={this.auditDetail.isTitleEditable ? 'p-2' : 'pr-2'}
        >
          {!this.auditDetail.isTitleEditable ? (
            <div className='field-title'>
              <span className='field-title-text'>{audit.title}</span>
              <span className='field-title-icon' onClick={this.auditDetail.toggleTitleEditable}>
                <Icon type='edit' />
              </span>
            </div>
          ) : (
            <Input
              rows={1}
              placeholder={`Audit at ${audit.locationName}`}
              value={this.auditDetail.auditTitle}
              onChange={(e) => this.auditDetail.setAuditTitle(e.target.value)}
              onPressEnter={() => this.auditDetail.updateTitle()}
              addonAfter={<Icon type='check' onClick={() => this.auditDetail.updateTitle()} />}
            />
          )}
        </Descriptions.Item>
        <Descriptions.Item label='Location'>{audit.locationName}</Descriptions.Item>
        <Descriptions.Item label='Employee'>
          <div className='field-employee'>{audit.startingUserName}</div>
        </Descriptions.Item>
        <Descriptions.Item label={`${BLAZE_COMPANY} ID`}>{audit.id}</Descriptions.Item>
        <Descriptions.Item label='Created'>
          {moment(audit.createDate).format('MMM D, YYYY h:mm a')}
        </Descriptions.Item>
        <Descriptions.Item label='Completed'>
          {audit.completeDate ? moment(audit.completeDate).format('MMM D, YYYY h:mm a') : '-'}
        </Descriptions.Item>
        <Descriptions.Item label='Progress'>
          <div className='field-progress'>
            <span className='field-progress-bar'>
              {this.auditDetail.totalCount > 0 && (
                <div
                  className='field-progress-bar-active'
                  style={{
                    width: this.auditDetail.progressbarWidth,
                  }}
                />
              )}
            </span>
            <span>{`${this.auditDetail.countedCount} / ${this.auditDetail.totalCount}`}</span>
          </div>
        </Descriptions.Item>

        {auditStore.shouldDisplayQuantity && (
          <Descriptions.Item label='Discrepancies'>
            <div style={{ fontSize: 12 }}>
              <p className='mb-1'>
                Under
                <span className='ml-2 text-danger'>
                  -{this.auditDetail.totalLostQuantity.toFixed(2)} (
                  <Currency centValue={this.auditDetail.totalLostCost} />)
                </span>
              </p>
              <p className='mb-0'>
                Over
                <span className='ml-2 text-success'>
                  +{this.auditDetail.totalAddedQuantity.toFixed(2)} (
                  <Currency centValue={this.auditDetail.totalAddedCost} />)
                </span>
              </p>
            </div>
          </Descriptions.Item>
        )}
      </Descriptions>
    )
  }
}
